import React from "react";
import { Input} from 'antd';
import TextInput from "../Form/TextInput";

export default (props) =>{
// let disabled=disabled

  const id = JSON.stringify(props.id);

    return (
        <div style ={{marginTop : 20}}>
            <div style = {{position :"relative"}}>
                <Input 
                    onChange = {props.handleChange(id)}
                    value = {props.values[props.id]}
                    placeholder ={props.name}
                    disabled={props.code=="phnNo" ? true : false}
                    style = {{width:"80%",height : 45,fontSize : 14,padding : 8,marginLeft : 15,marginRight : 15,borderWidth : 1,borderColor : "#000",borderRadius : 5,}}
                    // keyboardType = { props.inputType == "number" ? "phone-pad" : "default"}
                    onBlur={props.handleBlur(id)}
                />
            { props.touched[props.id] && props.errors[props.id] && <p style={{color : "red",fontSize : 12,textAlign : "left",position : "relative",marginLeft : 40,marginBottom : 20,marginTop : 10}}>{ props.errors[props.id]}</p>}
            </div>
        </div>
    )
}

// const styles = StyleSheet.create({
//     inputItem: {
//         height: 50,
//         borderWidth: 0.5,
//         width: deviceWidth-50,
//         borderRadius: 5,
//         marginTop: 30,
//       },
//       errorInputItem: {
//         height: 50,
//         borderColor: "red",
//         borderWidth: 0.5,
//         width: deviceWidth-50,
//         borderRadius: 5,
//         marginTop: 20,
//       },
//       buttonTxtStyle: {
//         textAlign: "center",
//         fontFamily: "roboto-medium",
//         fontSize: 18,
//         color: "white"
//       },
//       labelStyle:{
//         marginLeft:5,
//         fontSize : 13.5
//       },
//       errorText :{
//         margin:3,
//         color:"red",
//        // marginLeft:30
//       },
// })